import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { SoundEnum } from "src/app/enums/sound.enum";
import { TranslateService } from "@ngstack/translate";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { IDiscountGroupByTermInfo } from "src/app/interfaces/discountGroup-byTermInfo";
import { CourseService } from "./../../../../services/http/business/course/course.service";
import { RegistrationService } from "src/app/services/http/business/registration/registration.service";
import { MatTableDataSource } from "@angular/material";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-private-course-price',
  templateUrl: './private-course-price.component.html',
  styleUrls: ['./private-course-price.component.css']
})
export class PrivateCoursePriceComponent implements OnInit {

  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    this.translate.get("label.name"),
    this.translate.get("label.nationalCode"),
    this.translate.get("label.mobile"),
    this.translate.get("label.registrationStatus"),
    this.translate.get("label.finalPayment")
  ];

  form: FormGroup;
  termName: string;
  roomTitle: string;
  room: any;
  branchName: string;
  courseTypeName: string;
  minDate: any;
  maxDate: any;
  courseTime: any;
  startDate: any;
  hideTeacher: boolean = true;
  hidePicker: boolean = true;
  sexualityName: any;
  sexualityId: number;
  sexualities: any;
  levelInfoId: number;
  teachersList: [{}];
  coursePatternList = [];
  discountGroupList: IDiscountGroupByTermInfo[];
  roomList = [];
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  showGender: boolean = true;
  firstDate: any;
  endDate: any;
  levelCapacity: number;
  coefficient: any;

  price: number;
  regListCount: number;

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private registrationService: RegistrationService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private courseService: CourseService,
    private dialogRef: MatDialogRef<PrivateCoursePriceComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }


  ngOnInit() {
    this.createForm();
    this.getPrivateCoursePrice();
    if (this.data.ActiveAddInvoice)
      this.showStudents();
  }

  createForm() {
    this.form = this.fb.group({
      CourseId: [this.data.Id],
      Price: [this.data.Price, Validators.required]
    });
  }

  showStudents() {
    this.registrationService.registerStudentList({ Id: this.data.Id }).subscribe(res => {
      this.dataSource = res.DataList;
      this.regListCount = res.DataList.length;
    }, () => { })
  }

  calcPriceForStudent() {
    return this.price / this.regListCount;
  }

  addPrivateClassRegistrationInvoice() {
    this.registrationService.addPrivateClassRegistrationInvoice({ CourseId: this.data.Id }).subscribe(() => {
      this.dialogRef.close();
      this.snackBar.OpenSnackBar(
        'فاکتور دانشجویان با موفقیت صادر شد',
        "ok",
        5000,
        SoundEnum.beep
      );
    }, () => { })
  }

  getPrivateCoursePrice() {
    this.courseService.GetPrivateCoursePrice(this.data.Id).subscribe(res => {
      this.form.controls['Price'].patchValue(res.returnValue);
      this.price = res.returnValue;
    })
  }


  submit(form: any) {
    this.errors = new Array();
    this.courseService.SetPrivateCoursePrice(form).subscribe(
      () => {
        this.dialogRef.close(form);
        this.snackBar.OpenSnackBar(
          'قیمت کلاس با موفقیت ویرایش شد',
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }


  onNoClick(): void {
    this.dialogRef.close();
  }


}

